import React from 'react';
import { FiCode, FiShoppingCart, FiSmartphone } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiCode />,
        title: 'Software personalizzati',
        description: 'Sviluppiamo soluzioni su misura.<br />Valuta un gestionale personalizzato oppure integra quello che usi.',
        link: '/sviluppo-software-personalizzato'
    },
    {
        icon: <FiShoppingCart />,
        title: 'Siti web / eCommerce',
        description: 'Siti corporate, siti eCommerce.<br />Dal primo incontro ci focalizziamo sul raggiungimento dei tuoi obbiettivi.',
        link: '/realizzazione-siti-web-ecommerce'
    },
    {
        icon: <FiSmartphone />,
        title: 'App desktop & mobile',
        description: 'App Android & App iOS.<br />Per essere sempre visibili su qualsiasi dispositivo.',
        link: '/sviluppo-app-mobile-desktop'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                <Link className="btn-default btn-small round btn-icon mt-5" to={val.link}>Approfondisci</Link>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;